import axios from "axios";

export const getCompanyDetailsAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/company/getSingleCompany?id=${payload.companyid}`,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response.data.singleCompanyDetails[0];
};

export const search = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/company/search?name=${payload}`
  );
  return response.data.search;
};

export const userManagementSearch = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/company/userManagementSearch?name=${payload?.searchCharecters}&companyId=${payload?.companyId}`
  );
  return response.data.search;
};

// get each company details
export const getEachCompanyDetailsAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/company/getSingleCompany?id=${payload.id}`,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response.data.singleCompanyDetails[0];
};

//  get each user details
export const getEachUserDetailsAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/company/getSingleUser?userid=${payload.userid}`,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );
  return response.data.singleUserDetails;
};

// update each company details
export const updateEachCompanyDetailsAction = async (payload) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/company/updateCompanyDetails?id=${payload.id}`,
    payload
  );

  return response.data;
};

// add/create new company
export const addNewCompanyAction = async (payload) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/company/createCompany?parentCompany=${payload.parentCompanyId}`,
    payload.body,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response.data;
};

// add user
export const addUserAction = async (payload) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/company/addChildUser?parentCompanyid=${payload.parentCompanyid}`,
    payload.body,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response.data;
};

export const editCompanyAction = async (payload) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/company/updateCompany?id=${payload.companyId}`,
    payload.body,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response;
};

export const getAllCompaniesAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/company/getallCompany`,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response?.data?.data;
};

export const editSettingsAction = async (payload) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/company/editGeneralSettings?companyId=${payload.id}`,
    payload.body,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response;
};

export const updateCompanyPermissionAction = async (payload) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/company/updateCompanyPermission?companyId=${payload.id}`,
    payload.body,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response;
};
